<template>
  <div>
    <form @submit.prevent="onSubmit"
          class="row gutter-sm column"
          @keydown="form.onKeydown($event)">

      <v-select path="partner_id"
                auto-select
                v-model="form.partner_id"
                :label="$t('Partner')"
                optional
                :options="partners"
                :form="form"
                v-if="enable_partner === '1' && user.role_id === 7 && $route.name === 'lending-point.order'"
                class="col-sm-12 col-xs-12">
      </v-select>

      <div class="row justify-between" :style="$q.screen.gt.sm ? 'height:86px !important;' : ''">
        <v-input path="firstname"
                 :class="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('firstname') ? 'form-error' : ''"
                 v-model="form.firstname"
                 :label="$t('first name')"
                 :form="form"
                 class="col-sm-5 col-xs-12"
                 clearable
                 @blur=isError($event,form.firstname)>
        </v-input>
        <v-input path="lastname"
                 class="col-sm-5 col-xs-12"
                 :class="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('lastname') ? 'form-error' : 'hide-bottom-space'"
                 v-model="form.lastname"
                 :label="$t('last name') + ' *'"
                 :form="form"
                 clearable
                 @blur=isError($event,form.lastname)>
        </v-input>
      </div>

      <div class="row justify-between" :style="$q.screen.gt.sm ? 'height:86px !important;' : ''">
        <div class="row items-end col-sm-5 col-xs-12">
          <v-select path="phone_prefix"
                    auto-select
                    v-model="form.phone_prefix"
                    label="Teléfono móvil *"
                    :item-plural="$t('phone prefixes')"
                    :options="phonePrefixes"
                    class="col-sm-4 col-xs-5 q-field-no-line-color"
                    :class="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('phone') ? 'form-error-phone-prefix-placeholder' : ''"
                    :style="!isMobile && form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('phone') ? 'margin-bottom:18px;' : isMobile && form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('phone') ? 'margin-bottom:18px;' : ''"
                    :form="form">
          </v-select>
          <v-input path="phone"
                   v-model="form.phone"
                   :form="form"
                   :type="'tel'"
                   clearable
                   class="col-sm-8 col-xs-7 q-pl-xs"
                   :class="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('phone') ? 'form-error form-error-phone' : ''"
                   :style="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('phone') ? 'margin-bottom: 18px;' : ''"
                   @blur=isError($event,form.phone)>
          </v-input>

        </div>
        <v-input path="email"
                 :class="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('email') ? 'form-error' : ''"
                 v-model="form.email"
                 :label="$t('email') + ' *'"
                 :form="form"
                 clearable
                 :type="'email'"
                 class="col-sm-5 col-xs-12"
                 @blur=isError($event,form.email)>
        </v-input>
      </div>

      <div class="row justify-between" :style="$q.screen.gt.sm ? 'height:86px !important;' : ''">
        <v-input path="dni"
                 :class="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('dni') ? 'form-error' : ''"
                 v-model="form.dni"
                 :label="$t('dni/nie')"
                 :form="form"
                 clearable
                 class="col-sm-5 col-xs-12"
                 @blur=isError($event,form.dni)>
        </v-input>

        <v-datetime-picker
            ref="date-picker"
            v-if="form.hasOwnProperty('birthdate')"
            @blur=isErrorDatetime($event,form.birthdate)
            @change=isErrorDatetime($event,form.birthdate)
            @close=isErrorDatetime($event,form.birthdate)
            @input=isErrorDatetime($event,form.birthdate)
            :class="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('birthdate') ? 'form-error form-error-birthdate' : ''"
            class="birthdate-form col-sm-5 col-xs-12 col q-input-target q-no-input-spinner ellipsis"
            :placeholder="$t('birth date with help')"
            v-model="form.birthdate"
            :form="form"
            path="birthdate"
            :maxDate="maxDate"
            :disable-mobile="true"
        >
        </v-datetime-picker>
      </div>

      <div class="row justify-between" :style="$q.screen.gt.sm ? 'height:86px !important;' : ''">
        <v-input path="zipcode"
                 :class="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('zipcode') ? 'form-error' : ''"
                 class="col-sm-5 col-xs-12"
                 v-model="form.zipcode"
                 :label="$t('zip code') + ' *'"
                 :form="form"
                 clearable
                 @blur=isError($event,form.zipcode)>
        </v-input>

        <v-input path="city"
                 :class="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('city') ? 'form-error' : ''"
                 v-model="form.city"
                 :label="$t('city')"
                 :form="form"
                 class="col-sm-5 col-xs-12"
                 clearable
                 @blur=isError($event,form.city)>
        </v-input>

        <v-checkbox path="optional"
                    v-model="form.live_abroad"
                    :extra-html="live_abroadLabel"
                    :color="'primary'"
                    class="no-line col-sm-5 col-xs-12"
                    :form="form">
        </v-checkbox>
      </div>

      <div class="row justify-between" :style="$q.screen.gt.sm ? 'height:86px !important;' : ''">
        <v-select path="gender"
                 :options="genderOptions"
                 class="col-sm-5 col-xs-12"
                 :class="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('gender') ? 'form-error' : ''"
                 v-model="form.gender"
                 :label="$t('gender') + ' *'"
                 :form="form"
                 clearable
                 @blur=isError($event,form.gender)>
        </v-select>

        <v-select v-if="lendingKits.length"
                  path="lending_kit_id"
                  :class="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('lending_kit_id') ? 'form-error' : ''"
                  class="col-sm-5 col-xs-12"
                  v-model="form.lending_kit_id"
                  :label="$t('lending kit')"
                  :item-plural="$t('lending kits')"
                  :options="lendingKits"
                  :form="form"
                  @blur=isError($event,form.lending_kit_id)>
        </v-select>
        <v-display v-else
                   :class="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('lending_kit_id') ? 'form-error' : ''"
                   v-model="form.lending_kit_id"
                   :label="$t('lending kit')"
                   :form="form"
                   :color="'primary'"
                   class="col-sm-5 col-xs-12"
                   :empty-message="$t('you dont have lending kits available to loan')">
        </v-display>
      </div>

      <!-- <div class="row justify-between" :style="$q.screen.gt.sm ? 'height:86px !important;' : ''">
       <v-display v-model="startLendingAt"
                   :id="startLendingAt ? 'displayComponent' : ''"
                   :label="$t('lending start date') + ' *'"
                   :form="form"
                   :color="'primary'"
                   class="col-sm-5 col-xs-12">
        </v-display>

        <v-datetime path="end_lending_at"
                    :class="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('end_lending_at') ? 'form-error' : ''"
                    class="datetime-form col-sm-5 col-xs-12"
                    v-model="form.end_lending_at"
                    :label="$t('lending end date') + ' *'"
                    format-data="YYYY-MM-DD"
                    format="DD-MM-YYYY"
                    :form="form"
                    :min="minEndLendingAt"
                    :clearable="false"
                    @blur=isErrorEndLendingAt($event,form.end_lending_at)
                    @input=isErrorEndLendingAt($event,form.end_lending_at)
                    @change=isErrorEndLendingAt($event,form.end_lending_at)
                    disabled="disabled">
        </v-datetime>
      </div> -->


      <!-- <v-select path="document_type"
                auto-select
                v-model="form.document_type"
                :label="$t('document type')"
                :item-plural="$t('document types')"
                :options="documentTypes"
                :form="form"
                :clearable="false"
                class="col-sm-3 col-xs-12">
      </v-select> -->


      <!-- <v-select path="consumer_type_id"
                auto-select
                v-model="form.consumer_type_id"
                :label="$t('consumer type')"
                :item-plural="$t('consumer types')"
                :options="mockData.consumerTypes"
                :form="form"
                class="col-sm-6 col-xs-12">
      </v-select> -->


      <!-- REMOTE COACH -->
      <div class="col-12" v-if="$route.name === 'remote-coach.reservation'">
        <div class="row gutter-sm">

          <div class="col-8">
            <div tabindex="-1"
                 class="q-if row no-wrap relative-position q-input q-if-standard q-if-has-content text-highlight">
              <div class="q-if-baseline">|</div>
              <div class="q-if-inner col column">
                <div class="row no-wrap relative-position"><span
                    class="q-if-addon q-if-addon-left q-if-addon-visible">{{ $T('search') }}:&nbsp;</span>
                  <!-- <gmap-autocomplete :value="consumerLocation" class="col q-input-target q-no-input-spinner ellipsis"  @place_changed="setPlace"/> -->
                  <gmap-autocomplete class="col q-input-target q-no-input-spinner ellipsis"
                                     select-first-on-enter
                                     @keypress.13.prevent=""
                                     @place_changed="setPlace"/>
                </div>
              </div>
            </div>
          </div>

          <div class="col-4">
            <v-input path="filterKey"
                     v-model="filterKey"
                     :prefix="`${$T('filter')}:&nbsp;`"
                     :form="form">
            </v-input>
          </div>

          <div class="col-8">

            <GmapMap :center="mapCenter"
                     :zoom="mapZoom"
                     map-type-id="roadmap"
                     style="width: 100%; height: 400px">
              <gmap-marker v-for="(lendingPoint, i) in lendingPointsWithStock"
                           :key="i"
                           :position="parseCoords(lendingPoint.coords)"
                           :clickable="true"
                           :title="lendingPoint.description"
                           @click="select(lendingPoint)"
              ></gmap-marker>
              <gmap-marker v-if="consumerLocation" :position="consumerLocation"
                           :icon="'https://img.icons8.com/cotton/64/000000/men-age-group-4.png'"/>
            </GmapMap>

          </div>
          <div class="col-4">

            <q-scroll-area style="width: 100%; height: 400px; border: 1px solid #ddd">
              <q-list inset-separator no-border link>
                <q-item v-for="(lendingPoint, i) in filteredLendingPoints"
                        :key="i" multiline
                        @click.native="select(lendingPoint)">
                  <q-item-side
                      :icon="isSelected(lendingPoint) ? 'check circle' : 'place'"
                      inverted
                      :color="isSelected(lendingPoint) ? 'highlight' : 'primary'"/>
                  <q-item-main>
                    <q-item-tile label>{{ lendingPoint.description }}</q-item-tile>
                    <q-item-tile sublabel>
                      {{ lendingPoint.address }},
                      {{ lendingPoint.address_2 }} -
                      {{ lendingPoint.city }},
                      {{ lendingPoint.zipcode }}
                    </q-item-tile>
                    <q-item-tile sublabel>
                      {{ $T('distance') }}
                      {{ distanceInMeter(consumerLocation, parseCoords(lendingPoint.coords)) }}
                    </q-item-tile>
                  </q-item-main>
                  <q-item-side right :stamp="`${unitsFrom(lendingPoint)} ${$T('un.')}`"/>
                </q-item>
              </q-list>
            </q-scroll-area>

          </div>
        </div>
      </div>
      <!-- END REMOTE COACH -->


      <!-- <v-display :value="$T('privacy policy, terms and conditions, commercial communications')"
              :form="form"
              class="col-12"
              color="grey"
              v-if="$route.name !== 'remote-coach.reservation'"
              style="cursor: pointer;"
              @click.native.prevent="termsAndConditions = true">
      </v-display> -->

      <!-- <v-input path="observations"
              v-model="form.observations"
              :label="$t('observations')"
              optional
              :form="form"
              type="textarea"
              v-if="$route.name !== 'remote-coach.reservation'"
              class="col-12">
      </v-input> -->

      <div class="column styled-checkbox">
        <v-checkbox path="optional"
                    v-model="form.guided_trial"
                    :extra-html="guidedTrialLabel"
                    :form="form"
                    class="col-12">
                    <!--v-if="this.user.hasOwnProperty('enable_guided_trial') && this.user.enable_guided_trial"> -->
        </v-checkbox>
        <!--<v-checkbox path="accepted"
                    v-model="form.terms_and_conditions"
                    :extra-html="privacyLabel"
                    :color="'primary'"
                    class="no-line"
                    :form="form">
        </v-checkbox>
        <v-checkbox path="optional"
                    v-model="form.follow_up"
                    :extra-html="optionalLabel"
                    :color="'primary'"
                    class="no-line"
                    :form="form">
        </v-checkbox> -->
        <v-checkbox path="combined"
            v-model="combinedTermsAndConditions"
            :extra-html="combinedLabel"
            :color="'primary'"
            class="no-line"
            :form="form">
        </v-checkbox>
        <v-checkbox path="optional"
                    v-model="form.fee_payment"
                    :extra-html="fee_paymentLabel"
                    :color="'primary'"
                    class="no-line"
                    :form="form">
        </v-checkbox>
      </div>

      <input type="hidden" name="sms_code" :value="form.sms_code">

      <!-- Submit Button -->
      <div class="col-12 row justify-center q-mt-md">
        <v-button rounded
                  :label="$T('save')"
                  color="primary"
                  class="no-shadow q-btn-iqos"
                  :loading="form.busy"
                  :disable="form.busy"
                  @click.native.prevent="orderSubmit">
          <template slot="loading">
            <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
            {{ $T('saving...') | capitalize }}
          </template>
        </v-button>
      </div>

    </form>
    <q-dialog
        v-model="termsAndConditionsModal"
        prevent-close
    >
                        <span class="text-weight-bold" slot="title">
                             <div class="row justify-end">
                                <q-icon name="fa icon-close cursor-pointer"
                                        @click.native="termsAndConditionsModal = false"/>
                             </div>
                             <div class="column items-center" :class="isMobile ? '' : 'dialog-padding'">
                                {{ $T('terms and conditions') }}
                                <hr class="q-mt-sm q-mb-xl modal-hr" width="100%">
                             </div>
                        </span>

      <span class="text-center" slot="message">
                              <div class="column items-center" :class="isMobile ? '' : 'dialog-padding'">
                                 <span>{{
                                     $T('to create a order you need to accept the terms and conditions first')
                                   }}</span>
                             </div>
                        </span>

      <template slot="buttons" slot-scope="props">
        <div
            :class="isMobile ? 'column reverse half-width justify-between' : 'row full-width justify-around q-mb-lg dialog-padding'"
            class="items-center">
          <q-btn size="md" :class="isMobile ? 'q-mb-md full-width' : 'col-3'" class="capitalize"
                 color="highlight"
                 text-color="primary" rounded :label="$t('ok')" @click="termsAndConditionsModal = false"/>
        </div>
      </template>
    </q-dialog>
    <q-dialog
        v-model="customDialogModel"
        prevent-close
        @ok="newOrder"
        @cancel="goToList"
    >
                    <span class="text-weight-bold" slot="title">
                            <div class="row justify-end">
                                <q-icon name="fa icon-close cursor-pointer" @click.native="closeCustomDialog"/>
                            </div>
                            <div class="column items-center" :class="isMobile ? '' : 'dialog-padding'">
                                {{ messageModal }}
                                <hr class="q-mt-sm q-mb-xl modal-hr" width="100%">
                            </div>
                    </span>

      <template slot="buttons" slot-scope="props">
        <div
            :class="isMobile ? 'column reverse half-width justify-between' : 'row full-width justify-around q-mb-lg dialog-padding'"
            class="items-center">
          <q-btn size="md" :class="isMobile ? 'q-mb-md full-width' : 'col-3'" no-caps outline rounded
                 color="primary"
                 :label="$T('go to list')" @click="props.cancel"/>
          <q-btn size="md" :class="isMobile ? 'q-mb-md full-width' : 'col-3'" no-caps color="highlight"
                 text-color="primary" rounded :label="`${$T('new')} ${$T('order')}`" @click="props.ok"/>
        </div>
      </template>
    </q-dialog>
    <q-dialog
        v-model="validateSmsModal"
        prevent-close
    >
                        <span class="text-weight-bold" slot="title">
                             <div class="row justify-end">
                                <q-icon name="fa icon-close cursor-pointer"
                                        @click.native="validateSmsModal = false"/>
                             </div>
                             <div class="column items-center" :class="isMobile ? '' : 'dialog-padding'">
                                {{ $T('validate mobile phone') }}
                                <hr class="q-mt-sm q-mb-xl modal-hr" width="100%">
                             </div>
                        </span>

      <span class="text-center" slot="message">
                              <div class="column items-center" :class="isMobile ? '' : 'dialog-padding'">
                                 <span>{{
                                     $T('to create a order you need to validate mobile phone, entering the validate code sent to customer')
                                   }}</span>
                                 <v-input path="validate_sms_code"
                                          :class="form.hasOwnProperty('errors') && form.errors.hasOwnProperty('errors') && form.errors.errors.hasOwnProperty('validate_sms_code') ? 'form-error' : ''"
                                          v-model="form.validate_sms_code"
                                          :label="$t('validate sms code')"
                                          :form="form"
                                          class="col-sm-5 col-xs-12"
                                          clearable
                                          @blur=isError($event,form.validate_sms_code)>
        </v-input>
                             </div>
                        </span>

      <template slot="buttons" slot-scope="props">
        <div
            :class="isMobile ? 'column reverse half-width justify-between' : 'row full-width justify-around q-mb-lg dialog-padding'"
            class="items-center">
          <q-btn
              size="md"
              :class="isMobile ? 'q-mb-md full-width' : 'col-3'"
              class="capitalize"
              color="highlight"
              text-color="primary"
              rounded
              :label="$t('cancel')"
              @click="termsAndConditionsModal = false"/>
          <q-btn
              size="md"
              :class="isMobile ? 'q-mb-md full-width' : 'col-3'"
              class="capitalize"
              color="highlight"
              text-color="primary"
              rounded
              :label="$t('validate')"
              :loading="form.busy"
              :disable="form.busy"
              @click.native.prevent="validateSmsCode"/>
        </div>
      </template>
    </q-dialog>
  </div>
</template>

<script>
import Form from 'vform'
import moment from 'moment'
import axios from 'axios'
import {
  QSpinnerPuff,
  QSlideTransition
} from 'quasar-framework'
import orderModel from '../orderModel'
import phoneprefixes from '../../helpers/phonePrefix'
import TermsAndConditions from "../termsAndConditions"
import VDisplay from "../../components/form/VDisplay"
import {mapGetters} from 'vuex'
import helpers from '../../helpers/methods'
import VField from "../../components/form/VField"
import Detail from "../backoffice/lending-point/detail"
import { EventBus } from '../../plugins/event-bus'

export default {
  middleware: 'auth',

  mixins: [orderModel, phoneprefixes, helpers],

  components: {
    Detail,
    VField,
    VDisplay,
    TermsAndConditions,
    QSpinnerPuff,
    QSlideTransition
  },

  props: {
    mockData: Object
  },

  data() {
    return {
      newLendingFromBrokenKit: false,
      consumerLocation: '',
      distance: '',
      form: {},
      validateSmsModal: false,
      documentTypes: [
        {value: 'dni', label: this.$T('dni/nie')},
        {value: 'other', label: this.$T('other')}
      ],
      termsAndConditions: false,
      lendingKits: [],
      minBirthdayDate: moment('19200101', 'YYYYMMDD').format('YYYY-MM-DD'),
      maxBirthdayDate: moment().subtract(18, 'years').format('YYYY-MM-DD'),
      mapZoom: 6,
      mapCenter: {
        lat: 40.4378698,
        lng: -3.8196193
      },
      filterKey: '',
      enable_partner: false,
      partners: [],
      isMobile: true,
      termsAndConditionsModal: false,
      maxDate: moment().format('DD-MM-YYYY'),
      errorInDatePicker: false,
      customDialogModel: false,
      messageModal: '',
      numberPattern: /\d+/g,
      genderOptions: [
                    {value: 1, label: this.$T("gender male")},
                    {value: 0, label: this.$T("gender female")}
                ]
    }
  },

  computed: {
    startLendingAt() {
      if (this.newLendingFromBrokenKit) return moment(this.form.start_lending_at).format('DD-MM-YYYY')
      return moment().format('DD-MM-YYYY')
    },

    endLendingAt() {
      return moment().add(this.mockData.lendingDays, 'days').format('YYYY-MM-DD')
    },

    minEndLendingAt() {
      return moment().add(this.mockData.minimumLendingDays, 'days').format('YYYY-MM-DD')
    },
    minBirthdate() {
      return moment().add(this.mockData.minimumLendingDays, 'days').format('YYYY-MM-DD')
    },
    ...mapGetters({
      user: 'auth/user'
    }),

    lendingPointsWithStock() {
      return this.mockData['lendingPoints'].filter(item => this.unitsFrom(item) > 0)
    },
    filteredLendingPoints() {
      let filterKey = this.filterKey && this.filterKey.toLowerCase()
      let data = this.lendingPointsWithStock
      if (filterKey) {
        data = data.filter(row => Object.keys(row)
            .some(key => String(row[key]).toLowerCase().indexOf(filterKey) > -1))
      }
      return data
    },
    combinedTermsAndConditions: {
      get() {
        return this.form.terms_and_conditions && this.form.follow_up;
      },
      set(value) {
        this.form.terms_and_conditions = value;
        this.form.follow_up = value;
      }
    },
    privacyLabel() {
      return '<p class="q-ma-none text-primary font-label q-ml-md">He leído y acepto los <a href="http://iqos.buzz/TC_IQOS" target="_blank" class="styled-link">Términos y Condiciones</a> y la <a href="https://es.iqos.com/es/legal#politica-de-privacidad" target="_blank" class="styled-link">Política de Privacidad</a> de Philip Morris Spain *</p>'
    },
    combinedLabel() {
      return '<p class="q-ma-none text-primary font-label q-ml-md">El usuario se compromete a informar al adulto referido que ha comunicado sus datos a Philip Moriris Spain, de los aspectos básicos en materia de protección de datos y que PMS podrá contactarle con la finalidad de confirmar su condición de fumador adulto y obtener su consentimiento para el envío de información sobre productos y/o servicios de Philip Morris Spain. <a href="https://www.pmiprivacy.com/spain/es/consumer/" target="_blank">Política de privacidad</a> *</p>'
    },
    optionalLabel() {
      return '<p class="q-ma-none text-primary font-label q-ml-md">Quiero recibir comunicaciones comerciales (incluyendo email o medios de comunicación electrónica equivalentes) para formar parte de myIQOS.</p>'
    },
    fee_paymentLabel() {
        return '<p class="q-ma-none text-primary font-label q-ml-md">El usuario acepta pagar 1,50€ no reembolsables por el servicio de préstamo de IQOS en este punto de venta. *</p>'
    },
    live_abroadLabel() {
      return '<p class="q-ma-none text-primary font-label q-ml-md">Seleccionar si el usuario reside fuera de España</p>'
    },
    guidedTrialLabel() {
      return `<p class="q-ma-none text-primary font-label q-ml-md">${this.$T('this consumer came from guided trial')}</p>`
    }
  },

  watch: {
    errorInDatePicker(value) {
      let placeholder = this.$refs['date-picker'].$el.children[0].children[0].children[0]
      // console.log(this.$refs['date-picker'].$el)
      if (value) {
        this.$refs['date-picker'].$el.style.marginBottom = '-11px'
        this.$refs['date-picker'].$el.children[0].children[0].children[0].style.borderBottomColor = '#DB3624'
        this.$refs['date-picker'].$el.children[0].children[0].children[0].style.color = '#DB3624'
        placeholder.classList.add('color-error-placeholder')
      } else {
        this.$refs['date-picker'].$el.style.marginBottom = '14px'
        this.$refs['date-picker'].$el.children[0].children[0].children[0].style.borderBottomColor = '#00D1D2'
        this.$refs['date-picker'].$el.children[0].children[0].children[0].style.color = '#34303D'
        placeholder.classList.remove('color-error-placeholder')
      }
    },
    
    'form.dni'(newValue) {
      if (newValue && newValue.includes(' ')) {
        this.form.dni = newValue.replace(/\s+/g, '');
      }
    },
    'form.phone'(newValue) {
      if (newValue && newValue.includes(' ')) {
        const matches = newValue.match(this.numberPattern);
        this.form.phone = matches ? matches.join('') : '';
      }
    },
    'form.email'(newValue) {
      if (newValue && newValue.includes(' ')) {
        this.form.email = newValue.replace(/\s+/g, '');
      }
    },
    'form.zipcode'(newValue) {
      if (newValue && newValue.includes(' ')) {
        this.form.zipcode = newValue.replace(/\s+/g, '');
      }
    }
  },
  methods: {
    setup() {
      //Gets form data on the previous order marked as "Préstimo defeituoso")
      let formData = (this.$route.params && this.$route.params.hasOwnProperty('formData') && this.$route.params.formData) ? this.$route.params.formData : this.orderModel;
      if (formData['consumer_type.description']) {
        let index = this.mockData.consumerTypes.findIndex(type => {
          return type.label == formData['consumer_type.description']
        })
        if (index >= 0) {
          formData.consumer_type_id = this.mockData.consumerTypes[index].value
        }
      }
      this.enable_partner = this.mockData.enable_partner
      this.partners = this.mockData.partners.map(p => ({
        value: p.id,
        label: p.name
      }))

      this.$route.params.formData = {}
      this.form = new Form(formData)
      this.form.end_lending_at = this.endLendingAt
      this.form.minimum_lending_at = this.minEndLendingAt
      if (this.$route.name !== 'remote-coach.reservation') {
        this.lendingKits = this.loadLendingKits()
      }

      if (formData['start_lending_at']) {
        this.newLendingFromBrokenKit = true
        this.form.end_lending_at = formData['end_lending_at']
      }
      // For Remote Coach Map
      if (window.config.market === "CI") {
        this.mapZoom = 8.23
        this.mapCenter.lat = 28.3509903
        this.mapCenter.lng = -14.7892996
      }
    },

    closeCustomDialog() {
      this.customDialogModel = false
    },

    goToList() {
      this.$router.push({name: 'lending-point.orders'})
    },

    newOrder() {
      this.getUpdatedLendingKits()
      this.form.end_lending_at = this.endLendingAt
      this.form.minimum_lending_at = this.minEndLendingAt
      this.customDialogModel = false
      
      EventBus.$emit('resetStepper', 'consumer_eligibility')
      this.form = new Form(this.orderModel)
    },

    async sendSmsCode() {
      if (this.form.busy) {
        return
      }

      await this.form.post(`/api/v1/lending-point/order/send-sms-code`)
          .then(() => {
            this.validateSmsModal = true
          })
          .catch(error => console.error(error))
    },

    async validateSmsCode() {
      if (this.form.busy) {
        return
      }

      await this.form.post(`/api/v1/lending-point/order/validate-sms-code`)
          .then(async ({data}) => {
            if (data.valid_sms) {
              this.validateSmsModal = false
              await this.onSubmit()
            } else {
              this.$set(this.form.errors.errors, 'validate_sms_code', [
                this.$T('wrong validate code')
              ])
            }
          })
          .catch(error => console.error(error))
    },

    async onSubmit() {
      if (this.form.busy) return
      this.form.end_lending_at = this.endLendingAt;
      //console.log('Form data:', this.form);
      let response = await this.form.post(`/api/v1/lending-point/order`)
      if (!response.data) return
      let {data} = response
      this.form = new Form(this.orderModel)
      this.messageModal = data.success.message
      this.customDialogModel = true
      // this.$q.dialog({
      //     title: this.$T('success'),
      //     message: data.success.message,
      //     preventClose: true,
      //     color: 'primary',
      //     stackButtons: false,
      //     ok: {
      //         label: this.$T('go to list'),
      //         outline: true,
      //         rounded: true,
      //         color: 'primary',
      //         noCaps: true
      //     },
      //     cancel: {
      //         color: 'highlight',
      //         label: `${this.$T('new')} ${this.$t('order')}`,
      //         rounded: true,
      //         textColor: 'primary',
      //         noCaps: true
      //     }
      // }).then(() => {
      //     this.$router.push({name: 'lending-point.orders'})
      // }).catch(() => {
      //     this.getUpdatedLendingKits()
      //     this.form.end_lending_at = this.endLendingAt
      //     this.form.minimum_lending_at = this.minEndLendingAt
      // })
    },
    async getUpdatedLendingKits() {
      const {data} = await axios.get(`${config.appUrl}/api/v1/lending-point/order/form-mock-data`)
      this.lendingKits = data.data.lendingKits.map(item => ({
        label: `${item.codentify}`,
        value: item.id,
        sublabel: `${this.$T('product')}: ${item.product_model ? item.product_model.description : ''} ${item.product_color ? item.product_color.description : ''}, ${this.$T('child codentify 1')}: ${item.child_codentify_1}, ${this.$T('child codentify 2')}: ${item.child_codentify_2}`
      }))
    },
    acceptTermsAndConditions() {
      this.termsAndConditions = false;
    },
    orderSubmit() {
      if (this.$route.name === 'remote-coach.reservation') {
        if (this.mockData.enableSmsValidation == 1) {
          this.sendSmsCode()
        } else {
          this.onSubmit()
        }
      } else {
        if (!this.form.terms_and_conditions) {
          this.termsAndConditionsModal = true
        } else if (!this.form.fee_payment) {
          this.$q.notify({
            message: 'Acepte que ha abonado la tasa de 1,50€',
            type: 'negative',
            icon: 'warning',
            position: 'bottom-right',
            timeout: 0,
            closeBtn: true
           })
        } else {
          if (this.form.dni) {
            if (isValidDniNiePassport(this.form.dni)) {
              this.form.document_type = 'dni'
            } else {
              this.form.document_type = 'other'
            }
          }
          if (this.mockData.enableSmsValidation == 1) {
            this.sendSmsCode()
          } else {
            this.onSubmit()
          }
        }
      }
    },
    loadLendingKits() {
      return this.mockData.lendingKits.map(item => ({
        label: `${item.codentify}`,
        value: item.id,
        sublabel: `${this.$T('product')}: ${item.product_model ? item.product_model.description : ''} ${item.product_color ? item.product_color.description : ''}, ${this.$T('child codentify 1')}: ${item.child_codentify_1}, ${this.$T('child codentify 2')}: ${item.child_codentify_2}`
      }))
    },
    setPlace(place) {
      if (place && place.geometry) {
        this.mapCenter = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }
        this.consumerLocation = this.mapCenter
        this.mapZoom = 13
      }
    },
    unitsFrom(lendingPoint) {
      let kitsAvailable = lendingPoint.kits_available ? lendingPoint.kits_available.count : 0
      let reservations = lendingPoint.reservations ? lendingPoint.reservations.count : 0
      return kitsAvailable - reservations
    },
    isSelected(lendingPoint) {
      return this.form.lending_point_id == lendingPoint.id
    },

    select(lendingPoint) {
      if (this.form.lending_point_id == lendingPoint.id) {
        this.form.lending_point_id = null
        return
      }
      this.form.lending_point_id = lendingPoint.id
      this.form['order_status_id'] = 8
      this.mapCenter = lendingPoint.coords
      this.mapZoom = 16
      this.updateLendingKitList(lendingPoint.id)
      this.distance = this.distanceInMeter(this.consumerLocation, this.parseCoords(lendingPoint.coords))
    },
    async updateLendingKitList(lendingPointId) {
      if (lendingPointId === null) {
        lendingPointId = this.user.lending_point_id
      }
      const {data} = await axios.get(`${config.appUrl}/api/v1/lending-point/reservation/kits/${lendingPointId}`)
      this.lendingKits = data.map(item => ({
        label: `${item.codentify}`,
        value: item.id,
        sublabel: `${this.$T('product')}: ${item.product_model ? item.product_model.description : ''} ${item.product_color ? item.product_color.description : ''}, ${this.$T('child codentify 1')}: ${item.child_codentify_1}, ${this.$T('child codentify 2')}: ${item.child_codentify_2}`
      }))
    },
    distanceInMeter(p1, p2) {
      if (p1 && p2) {
        var vm = parseInt(google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(p1), new google.maps.LatLng(p2)))
        if (vm > 1000) {
          return (vm / 1000).toFixed(2) + ' Km'
        }
        return vm + ' m'
        return
      } else {
        return null
      }
    },
    parseCoords(value) {
      if (typeof (value) == 'string')
        try {
          value = JSON.parse(value);
        } catch (e) {
        }
      if (!this.isValidCoords(value))
        value = null

      return value
    },
    isValidCoords(value) {
      return value &&
          typeof value == 'object' &&
          'lat' in value &&
          value.lat &&
          typeof value.lat == 'number' &&
          'lng' in value &&
          value.lng &&
          typeof value.lng == 'number'
    },
    isError(e, isFilled) {
      if (!isFilled.trim()) {
        switch (e.target.name) {
          case 'firstname':
            this.$set(this.form.errors.errors, 'firstname', [
              this.$T('Field empty. Please fill.')
            ])
            break;
          case 'lastname':
            this.$set(this.form.errors.errors, 'lastname', [
              this.$T('Field empty. Please fill.')
            ])
            break;
          case 'phone':
            this.$set(this.form.errors.errors, 'phone', [
              this.$T('Field empty. Please fill.')
            ])
            break;
          case 'email':
            this.$set(this.form.errors.errors, 'email', [
              this.$T('Field empty. Please fill.')
            ])
            break;
          case 'dni':
            this.$set(this.form.errors.errors, 'dni', [
              this.$T('Field empty. Please fill.')
            ])
            break;
          case 'zipcode':
            this.$set(this.form.errors.errors, 'zipcode', [
              this.$T('Field empty. Please fill.')
            ])
            break;
          case 'lending_kit_id':
            this.$set(this.form.errors.errors, 'lending_kit_id', [
              this.$T('Field empty. Please fill.')
            ])
            break;
          case 'gender':
            this.$set(this.form.errors.errors, 'gender', [
              this.$T('Field empty. Please fill.')
            ])
            break;
          case 'city':
            this.$set(this.form.errors.errors, 'city', [
              this.$T('Field empty. Please fill.')
            ])
            break;
          default:
            break;
        }
      } else {
        switch (e.target.name) {
          case 'firstname':
            if (/\d/.test(this.form.firstname)) {
              this.$set(this.form.errors.errors, 'firstname', [
                'Introduzca un nombre correcto'
              ])
            } else if (this.form.firstname.length > 255) {
              this.$set(this.form.errors.errors, 'firstname', [
                'El nombre no debe ser mayor que 255 caracteres.'
              ])
            } else {
              if (this.form.errors.errors.hasOwnProperty('firstname')) {
                this.form.errors.errors.firstname.pop()
              }
            }
            break;
          case 'lastname':
            if (/\d/.test(this.form.lastname)) {
              this.$set(this.form.errors.errors, 'lastname', [
                'Introduzca un apellido correcto'
              ])
            } else if (this.form.lastname.length > 255) {
              this.$set(this.form.errors.errors, 'lastname', [
                'El apellido no debe ser mayor que 255 caracteres.'
              ])
            } else {
              if (this.form.errors.errors.hasOwnProperty('lastname')) {
                this.form.errors.errors.lastname.pop()
              }
            }
            break;
          case 'phone':
            let err = false
            if (isValidDniNiePassport(this.form.dni) && this.form.phone_prefix === '0034') {
              err = this.form.phone.length !== 9 || isNaN(this.form.phone) !== false || (!this.form.phone.startsWith('9') &&
                  !this.form.phone.startsWith('8') && !this.form.phone.startsWith('7') && !this.form.phone.startsWith('6') &&
                  !this.form.phone.startsWith('00'))
            } else {
              err = !isValidMobilePhone(this.form.phone)
            }

            if (err) {
              this.$set(this.form.errors.errors, 'phone', [
                'El teléfono no es válido.'
              ])
            } else {
              if (this.form.errors.errors.hasOwnProperty('phone')) {
                this.form.errors.errors.phone.pop()
              }
            }
            break;
          case 'email':
            if (!isValidEmail(this.form.email)) {
              this.$set(this.form.errors.errors, 'email', [
                'El email no es válido'
              ])
            } else {
              if (this.form.errors.errors.hasOwnProperty('email')) {
                this.form.errors.errors.phone.pop()
              }
            }
            break;
          case 'dni':
            if (this.form.errors.errors.hasOwnProperty('dni')) {
              this.form.errors.errors.dni.pop()
            }
            break;
          case 'zipcode':
            if (isValidDniNiePassport(this.form.dni) && !isValidESZipCode(this.form.zipcode)) {
              this.$set(this.form.errors.errors, 'zipcode', [
                'Código postal no es válido'
              ])
            } else {
              if (this.form.errors.errors.hasOwnProperty('zipcode')) {
                this.form.errors.errors.zipcode.pop()
              }
            }
            break;
          case 'lending_kit_id':
            if (this.form.errors.errors.hasOwnProperty('lending_kit_id')) {
              this.form.errors.errors.lending_kit_id.pop()
            }
            break;
          default:
            break;
        }
      }
    },

    isErrorDatetime(e, date) {
      this.errorInDatePicker = false
      if (!date || !date.trim()) {
        this.$set(this.form.errors.errors, 'birthdate', [
          this.$T('Field empty. Please fill.')
        ])
        this.errorInDatePicker = true
      } else {
        let birthdate = moment(this.form.birthdate, "DD-MM-YYYY")
        if (moment().diff(birthdate, 'years') < 18) {
          this.$set(this.form.errors.errors, 'birthdate', [
            'El cliente debe ser hace al menos 18 años.'
          ])
          this.errorInDatePicker = true
        } else if (moment(birthdate).format('Y') < 1920) {
          this.$set(this.form.errors.errors, 'birthdate', [
            'La fecha de nacimiento no puede ser anterior a 1920'
          ])
          this.errorInDatePicker = true
        } else {
          if (this.form.errors.errors.hasOwnProperty('birthdate')) {
            this.form.errors.errors.birthdate.pop()
            this.errorInDatePicker = false
          }
        }
      }
    },

    isErrorEndLendingAt(endLendingAt) {
      if (!endLendingAt.trim()) {
        this.$set(this.form.errors.errors, 'end_lending_at', [
          this.$T('Field empty. Please fill.')
        ])
      } else {
        let date = moment(this.form.end_lending_at, "YYYY-MM-DD")
        let maxLendingAt = moment(this.endLendingAt, "YYYY-MM-DD")
        let minEndLendingAt = moment(this.minEndLendingAt, 'YYYY-MM-DD')
        if (date.isBefore(minEndLendingAt)) {
          this.$set(this.form.errors.errors, 'end_lending_at', [
            'El fecha del fin del préstamo debe ser una fecha posterior o igual a ' + minEndLendingAt
          ])
        } else if (date.isAfter(maxLendingAt)) {
          this.$set(this.form.errors.errors, 'end_lending_at', [
            'El período de préstamo no debe ser superior a ' + this.mockData.lendingDays + ' días.'
          ])
          this.fieldEndLendingAtErrorLabel = 'El período de préstamo no debe ser superior a ' + this.mockData.lendingDays + ' días.'
        } else {
          if (this.form.errors.errors.hasOwnProperty('end_lending_at')) {
            this.form.errors.errors.birthdate.pop()
          }
        }
      }
    }
  },

  mounted() {
    this.setup()
    if (this.mockData.phone_number && this.mockData.phone_prefix) {
      this.form.phone = this.mockData.phone_number
      this.form.phone_prefix = this.mockData.phone_prefix
    }
    this.form.dni = this.mockData.dni
    this.form.email = this.mockData.email
    this.isMobile = this.$q.platform.is.mobile
  }
}
</script>

<style scoped>
@media (min-width: 768px) {
  .q-btn-iqos {
    letter-spacing: 0.125rem;
    text-transform: capitalize;
    font-size: 17px !important;
    border-width: 2px;
    padding: 0px 50px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/lending-point/orderForm.vue